module.exports = __webpack_public_path__ + "img/chevron-down.5f9bb4f3.svg";